// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m1WnSas4uQuxIM {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.UFgnVzFtLRoPLD {
  display: flex;
  justify-content: center;
}
.eYMu9CFmhldpCd {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.W7kGfE7LRCYoUX {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.bL46ISsYk_nZYq {
  font-style: italic;
}
.jrSMIK0A4wQd_R {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.btQ7Bq0dVav2OI {
  display: flex;
  align-items: center;
  justify-content: center;
}
.HIWq6j2tClG1uJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.HIWq6j2tClG1uJ .SRJTOhf7KV0z2W {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.tpw4iEDaQEO4lW {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.tpw4iEDaQEO4lW button {
  margin-left: var(--ds-space-100, 8px);
}
.UImNp2QnE0DyZ2 {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .jrSMIK0A4wQd_R {
    padding: var(--ds-space-200, 16px);
  }
}
.Z34FycvtPD0RDm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-100, 8px);
}
.Z34FycvtPD0RDm legend,
.Z34FycvtPD0RDm label {
  font-weight: var(--ds-font-weight-bold, 700);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
}
.Z34FycvtPD0RDm fieldset {
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  border: 0;
}
.Z34FycvtPD0RDm input[type='text'] {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-150, 12px);
}
.Z34FycvtPD0RDm input[type='text']:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.Z34FycvtPD0RDm input[type='text']:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.Z34FycvtPD0RDm input[type='text']:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.Z34FycvtPD0RDm input[type='text'][readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.Z34FycvtPD0RDm input[type='text'].wC9lDv3elfgqyF {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.Z34FycvtPD0RDm input[type='text'].wC9lDv3elfgqyF:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.Z34FycvtPD0RDm input[type='text'].wC9lDv3elfgqyF:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.Z34FycvtPD0RDm input[type='text'].sayqaFIO_7xarY {
  width: 100%;
}
.Z34FycvtPD0RDm input[type='text']::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.Z34FycvtPD0RDm input[type='radio'] {
  margin: var(--ds-space-0, 0);
  margin-right: var(--ds-space-100, 8px);
}
.s7bzYt4Loec2LC {
  min-width: 320px;
}
.QPVit3R52xSi6u {
  width: 181px;
  height: 32px;
}
.c4HxnfL2jrUkEk {
  min-width: 320px;
  height: 100px;
}
.c4HxnfL2jrUkEk a {
  text-decoration: unset;
}
.EDZOaDzOq5Cgjt {
  display: block;
  width: 275px;
  margin-top: 5px;
  color: var(--ds-text-danger, #ae2a19);
  font-size: 12px;
  font-weight: var(--ds-font-weight-bold, 700);
  line-height: 16px;
}
.cGDvTBQT5BtxLK {
  flex-grow: 1;
  margin-left: var(--ds-space-400, 32px);
}
.wOa4JXwdKeG6e4 {
  min-width: 320px;
}
.wOa4JXwdKeG6e4 label {
  display: flex;
}
.wOa4JXwdKeG6e4 label input {
  margin-right: var(--ds-space-100, 8px);
}
input[type='radio'].Bi6_93Bw1z8P8Z {
  box-shadow: unset;
}
@media only screen and (max-width: 900px) {
  .Z34FycvtPD0RDm {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .cGDvTBQT5BtxLK {
    margin-left: var(--ds-space-200, 16px);
    color: var(--ds-text-subtle, #44546f);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `m1WnSas4uQuxIM`,
	"flexAndCenter": `UFgnVzFtLRoPLD`,
	"body": `eYMu9CFmhldpCd`,
	"navigationAndContent": `W7kGfE7LRCYoUX`,
	"learnMoreSubtle": `bL46ISsYk_nZYq`,
	"content": `jrSMIK0A4wQd_R`,
	"spinnerContainer": `btQ7Bq0dVav2OI`,
	"header": `HIWq6j2tClG1uJ`,
	"title": `SRJTOhf7KV0z2W`,
	"footer": `tpw4iEDaQEO4lW`,
	"formFooter": `UImNp2QnE0DyZ2`,
	"formSection": `Z34FycvtPD0RDm`,
	"input-error": `wC9lDv3elfgqyF`,
	"full": `sayqaFIO_7xarY`,
	"pluginInput": `s7bzYt4Loec2LC`,
	"registerBtn": `QPVit3R52xSi6u`,
	"apiKey": `c4HxnfL2jrUkEk`,
	"isInvalidApiKey": `EDZOaDzOq5Cgjt`,
	"inputDescription": `cGDvTBQT5BtxLK`,
	"storesPersonalDataContainer": `wOa4JXwdKeG6e4`,
	"storesPersonalDataRadio": `Bi6_93Bw1z8P8Z`
};
export default ___CSS_LOADER_EXPORT___;
